import { Injectable, inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class RoleGuardService {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  canActivate(requiredRoles: UserRole[]): boolean {
    const currentUser = this.authService.getCurrentUser();
    
    if (!currentUser) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    if (requiredRoles.length === 0 || requiredRoles.includes(currentUser.role)) {
      return true;
    }

    // User doesn't have required role
    this.router.navigate(['/auth/unauthorized']);
    return false;
  }
}

// Functional guard for route protection by role
export const roleGuard = (requiredRoles: UserRole[]): CanActivateFn => {
  return (route: ActivatedRouteSnapshot) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const currentUser = authService.getCurrentUser();

    if (!currentUser) {
      router.navigate(['/auth/login']);
      return false;
    }

    if (requiredRoles.length === 0 || requiredRoles.includes(currentUser.role)) {
      return true;
    }

    router.navigate(['/auth/unauthorized']);
    return false;
  };
};
